import { Outlet } from 'react-router-dom'
import { GovBanner } from './GovBanner'
import { PublicHeader } from './PublicHeader'
import { PublicFooter } from './PublicFooter'

export function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:text-primary focus:px-3 focus:py-2 focus:rounded focus:shadow-lg"
      >
        Skip to main content
      </a>
      <GovBanner />
      <PublicHeader />
      <main id="main" className="flex-1 bg-white">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  )
}
